import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import ProjectCard from './components/ProjectCard';
import { connect } from 'react-redux';
import { getProjects } from 'Actions/projectActions';
import 'CSS/projects.scss';
import CircularProgress from '@material-ui/core/CircularProgress';
import NewProjectDialog from './../NewProjectDialog';
import AddCircle from '@material-ui/icons/AddCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import FormControl from '@material-ui/core/FormControl';
import ProjectInvitationCard from './../ProjectInvitationCard';
import ActiveProjectCard from './../ActiveProjectCard';
import lightBulb from 'Images/arup_welcome.svg';
import SearchIcon from '@material-ui/icons/Search';
import styled from 'styled-components';
// import { addDemandDashboardProject } from 'Actions/initActions';

const CreateNewProject = styled.div`
  // position: initial !important;
  // right: initial !important;
  // left: initial !important;
  // bottom: initial !important;
  padding-left: 15px;
`;
const Project = styled.div`
  cursor: pointer;
`;

const MenuItemWithArrow = styled(MenuItem)`
  justify-content: space-between !important;
  :focus {
    background-color: unset !important;
  }
  :hover {
    text-decoration: none !important;
    background-color: rgba(0, 0, 0, 0.08) !important;
  }
`;
const Name = styled.div`
  // display: flex;
`;
const InviWrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`;

// 75px - spinner size
const Loader = styled(CircularProgress)`
  margin-top: calc(50vh - 75px);
`;

class MyProjects extends React.Component {
  state = {
    hasProjects: false,
    filter: '',
    search: '',
    projects: [],
    newProjectDialogOpen: false,
    anchorEl: null,
    showArchive: false,
    projectsFilter: '',
    filteredProjects: false,
    sortDirection: 'asc',
    sortBy: 'name',
  };
  constructor(props) {
    super(props);
    props.getProjects();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let projects = nextProps.projects;
    let hasProjects = false;
    if (projects.length > 0) {
      hasProjects = true;
    }
    this.setState({ projects, hasProjects }, () => {
      if (!this.state.filteredProjects && projects.length > 0) {
        // this.setState({ filteredProjects: projects });
        this.sortProjects(this.state.sortBy, projects);
      }
      this.filterProjects(this.state.projectsFilter);
    });
  }

  handleOpenMenu = event => {
    this.setState({ anchorEl: true });
  };
  handleCloseMenu = event => {
    this.setState({ anchorEl: null });
  };
  handleChangeProjectFilter = showArchive => {
    this.setState({ showArchive });
    this.handleCloseMenu();
  };
  handleOpenProjectDialog = () => {
    this.setState({ newProjectDialogOpen: true });
  };
  handleCloseProjectDialog = () => {
    this.setState({ newProjectDialogOpen: false });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleFilterProjects = name => event => {
    this.setState({ [name]: event.target.value }, () =>
      this.filterProjects(this.state.projectsFilter)
    );
  };

  filterProjects = filterValue => {
    let filteredProjects = this.state.projects.filter(project =>
      Object.keys(project).some(key => {
        return String(project[key])
          .toLowerCase()
          .includes(
            String(filterValue)
              .toLowerCase()
              .trim()
          );
      })
    );
    this.sortProjects(this.state.sortBy, filteredProjects);
    // this.setState({ filteredProjects });
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  setSortBy = sortBy => () => {
    this.setState(
      {
        sortDirection: this.state.sortDirection === 'desc' ? 'asc' : 'desc',
        sortBy: sortBy,
      },
      () => {
        this.sortProjects(this.state.sortBy, this.state.filteredProjects);
      }
    );
  };

  sortProjects = (sortBy, sortThis) => {
    let sortDirection = this.state.sortDirection;
    let sortedFilteredProjects = JSON.parse(JSON.stringify(sortThis));
    if (sortDirection === 'asc') {
      sortedFilteredProjects = sortedFilteredProjects.sort(function(a, b) {
        if (sortBy === 'hasNotification') {
          return a[sortBy] - b[sortBy];
        } else return a[sortBy].localeCompare(b[sortBy]);
      });
    } else {
      sortedFilteredProjects = sortedFilteredProjects.sort(function(a, b) {
        if (sortBy === 'hasNotification') {
          return b[sortBy] - a[sortBy];
        } else return b[sortBy].localeCompare(a[sortBy]);
      });
    }
    this.setState({
      filteredProjects: sortedFilteredProjects,
    });
  };

  renderProjectInvitations = () => {
    if (this.props.invitations) {
      return this.props.invitations.map(invitation => (
        <ProjectInvitationCard
          key={invitation.projectId}
          invitation={invitation}
        />
      ));
    }
  };

  renderProjects = projects => {
    if (projects !== false) {
      return projects.map(project => {
        if (Number(project.id) === Number(this.props.currentProjectId)) {
          return (
            <ActiveProjectCard
              key={project.id}
              project={project}
              tickets={this.props.tickets}
              currentTicketId={this.props.currentTicketId}
              handleOpenShareDialog={this.props.handleOpenShareDialog}
            />
          );
        } else {
          return (
            <ProjectCard
              handleOpenShareDialog={this.props.handleOpenShareDialog}
              key={project.id}
              project={project}
            />
          );
        }
      });
    }
  };

  renderSortDirection = () => {
    let sortDir = this.state.sortDirection;

    if (this.state.sortBy !== 'name') {
      if (sortDir === 'asc') {
        sortDir = 'desc';
      } else {
        sortDir = 'asc';
      }
    }

    if (sortDir === 'asc') {
      return (
        <ArrowDropDown
          aria-label="More"
          aria-owns={this.state.anchorEl ? 'long-menu' : null}
          aria-haspopup="true"
          className="my-projects-arrow-down"
          // onClick={this.handleClick}
        />
      );
    } else {
      return (
        <ArrowDropUp
          aria-label="More"
          aria-owns={this.state.anchorEl ? 'long-menu' : null}
          aria-haspopup="true"
          className="my-projects-arrow-down"
          // onClick={this.handleClick}
        />
      );
    }
  };

  renderPage = () => {
    if (this.props.isLoading) {
      return <Loader size={75} />;
    }

    if (this.state.projects.length === 0) {
      return (
        // <div>
        <Grid item xs={9} className="u-mrg-bot-60 welcome-after-login-empty">
          <InviWrapper>{this.renderProjectInvitations()}</InviWrapper>
          <Grid container alignItems={'center'} justify={'center'} spacing={0}>
            <h2 className="t-align-c">Create your first project</h2>
          </Grid>
          <Grid container alignItems={'center'} justify={'center'} spacing={0}>
            <img className="u-mrg-bot-20" src={lightBulb} alt="" />
            <p className="t-secondary-14 t-align-c create-project-description">
              {/* Create a project and link it with Arup database adding specific
              Arup project number. In the project you can create search for any
              specific light type you need for your project. */}
              Create a new project and add an Arup job number. In a Luminaire
              Broker project you can create searches for all required project
              luminaire types.
            </p>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              className="u-mrg-top-57 u-mrg-bot-30 t-weight-b"
              onClick={this.handleOpenProjectDialog}
            >
              Create a project
            </Button>
            <p className="t-secondary-14 t-align-c create-project-description call-to-action-link">
              Not sure where to start? Visit our{' '}
              <Link to="/faq" className="link-bellaerodrow-button">
                Frequently asked questions
              </Link>
            </p>
          </Grid>
        </Grid>
        // </div>
      );
    } else {
      return (
        <Grid container alignItems={'center'} justify={'center'}>
          <Grid item xs={11} className="overflow-block">
            <div className="search-projects-box">
              <div className="my-projects-title">
                <Project onClick={this.handleClick}>
                  {!this.state.showArchive && (
                    <div className="element-inline-block">
                      <h2 className="t-secondary-30 element-inline c-p-blue-dark">
                        My projects
                        <span className="t-secondary-16 c-l-gray my-projects-counter">
                          (
                          {
                            this.state.projects.filter(
                              project => project.state === 'ACTIVE'
                            ).length
                          }
                          )
                        </span>
                      </h2>
                    </div>
                  )}
                  <ArrowDropDown
                    aria-label="More"
                    aria-owns={this.state.anchorEl ? 'long-menu' : null}
                    aria-haspopup="true"
                    className="my-projects-arrow-down"
                  />
                </Project>
                <Menu
                  // id="simple-menu"
                  className=""
                  open={Boolean(this.state.anchorEl)}
                  anchorEl={this.state.anchorEl}
                  onClose={this.handleCloseMenu}
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                  Sort by:
                  <MenuItemWithArrow key={0} onClick={this.setSortBy('name')}>
                    <Name>Name</Name>
                    {this.state.sortBy === 'name' && this.renderSortDirection()}
                  </MenuItemWithArrow>
                  <MenuItemWithArrow
                    key={1}
                    onClick={this.setSortBy('hasNotification')}
                  >
                    <Name>With notification</Name>
                    {this.state.sortBy === 'hasNotification' &&
                      this.renderSortDirection()}
                  </MenuItemWithArrow>
                  <MenuItemWithArrow
                    key={2}
                    onClick={this.setSortBy('createdDate')}
                  >
                    <Name>Date</Name>
                    {this.state.sortBy === 'createdDate' &&
                      this.renderSortDirection()}
                  </MenuItemWithArrow>
                </Menu>
              </div>
              {this.props.invitations && this.props.invitations.length > 0 && (
                <div className="projectsInvitationNotification">
                  <div className="notificationNumber">
                    {this.props.invitations.length}
                  </div>
                  <p>
                    project invitation
                    {this.props.invitations.length > 1 ? 's' : ''}
                  </p>
                </div>
              )}

              <FormControl className="u-mrg-top-10 w100 e-pos-r">
                <InputLabel
                  htmlFor="search"
                  classes={{
                    root: 'label--c-gray u-pad-l-30',
                  }}
                >
                  Search projects
                </InputLabel>
                <Input
                  classes={{
                    underline: 'underline--c-primary u-pad-l-30',
                  }}
                  id="filter-projects"
                  type="text"
                  label="Search projects"
                  value={this.state.projectsFilter}
                  onChange={this.handleFilterProjects('projectsFilter')}
                  fullWidth
                />
                <SearchIcon className="e-pos-a c-p_gray bot5" />
              </FormControl>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            // className="u-mrg-top-60"
          >
            <CreateNewProject
              onClick={this.handleOpenProjectDialog}
              // className="create-new-project t-weight-m t-primary-16 t-align-l pointer"
              className="create-new-project t-weight-m t-primary-16 t-align-l pointer"
            >
              <AddCircle className="add-icon" />
              Create new project
            </CreateNewProject>
          </Grid>
          <Grid item xs={12} className="scrollable-area">
            {/* <ScrollArea
              speed={0.8}
              className="area sidebar-scrollarea"
              contentClassName="content"
              horizontal={false}
            > */}
            <Grid
              container
              alignItems={'center'}
              justify={'center'}
              spacing={16}
              className="projects-sidebar"
            >
              {this.renderProjectInvitations()}
              {/*<Grid*/}
              {/*item*/}
              {/*xs={4}*/}

              {/*>*/}
              {/*<Paper*/}
              {/*className="project-card project-card-add-card"*/}
              {/*xs={12}*/}
              {/*onClick={this.props.handleOpen}*/}
              {/*>*/}
              {/*<AddCircle className="add-circle"/>*/}
              {/*<h2 className="t-primary-18">*/}
              {/*Create new project*/}
              {/*</h2>*/}
              {/*</Paper>*/}
              {/*</Grid>*/}
              {/*<ProjectCard/>*/}
              {/*<ProjectCard/>*/}
              {/*<ProjectCard/>*/}
              {this.renderProjects(this.state.filteredProjects)}
            </Grid>
            {/* </ScrollArea> */}
          </Grid>
        </Grid>
      );
    }
  };

  render() {
    return (
      <Grid
        container
        alignItems={'baseline'}
        justify={'center'}
        className={'projects-wrapper'}
      >
        {this.renderPage()}
        <NewProjectDialog
          newProjectDialogOpen={this.state.newProjectDialogOpen}
          handleClose={this.handleCloseProjectDialog}
          edit={false}
        />
      </Grid>
    );
  }
}
const mapStateToProps = store => {
  return {
    projects: store.projects.projects,
    isLoading: store.projects.isLoading,
    projectUsages: store.projects.projectUsages,
    tickets: store.currentProject.tickets,
  };
};

// const mapDispatchToProps = dispatch => ({
//   getProjects: () => {
//     dispatch(getProjects());
//   },
// });

export default connect(mapStateToProps, {
  getProjects,
  // , addDemandDashboardProject
})(MyProjects);
